// Generated by CoffeeScript 2.7.0
var TextField;

import Base from './base.js';

export default TextField = class TextField extends Base {};
